"use strict";

angular.module("customer")
.controller("UserManagementListController", function(
    $scope, $state, $stateParams, StateExtensionService, UserManagementService, UserService, ModalService,
    CUSTOMER_TYPE
) {
    $scope.isOwner = false;
    $scope.params = angular.extend({}, $stateParams);
    $scope.pagination = {};
    $scope.showAddButton = false;
    $scope.showOwnerButton = false;
    $scope.isCustomerTypeBusiness = true;

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.isOwner = user.is_owner;
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
            $scope.isCustomerTypeBusiness = user.customer && user.customer.type === CUSTOMER_TYPE["BUSINESS"];
            $scope.showAddButton = $scope.isOwner && !$scope.dedicatedVendorId;
            $scope.showOwnerButton = !$scope.isOwner;
        }
    });

    this.search = function() {
        UserManagementService.query($scope.params).$promise.then(function onSuccess(data) {
            $scope.pagination = data.pagination;
            $scope.userCustomers = data.results;
        });
    };

    this.seeDetails = function(id) {
        $state.go("userManagementForm", {id: id});
    };

    this.onPageChanged = function() {
        StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        this.search();
    };

    this.search();

    this.openOwnerDetails = function() {
        ModalService.showModal({
            templateUrl: require("./modals/owner-details.modal.html"),
            controllerAs: "ownerDetailsModalCtrl",
            controller: "OwnerDetailsModalController"
        }).then(function(modal) {
            modal.element.modal();
            modal.element.on("hidden.bs.modal", function() {
                modal.element.remove();
            });
        });
    };

    this.transferOwnership = function(event, userCustomerId) {
        event.stopPropagation();
        UserManagementService.transferOwnership(userCustomerId);
    };

    this.sendUserInvitation = function(event, userCustomerId) {
        event.stopPropagation();
        UserManagementService.sendUserInvitation(userCustomerId);
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/user-management/user-management-list.controller.js
// module id = 962
// module chunks = 0